import { services } from "@/mocks/services";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const serviceToCategory: Record<string, string> = {
  interior: "Interior",
  exterior: "Exterior",
  residential: "All",
  commercial: "Commercial",
  repairs: "Repair",
  pressure: "Pressure Washing",
};

export default function Services() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <section className="pt-28 pb-12 px-4 md:px-8 lg:px-12 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <div className="inline-flex items-center border border-foreground-300 rounded-full px-5 py-1.5 text-xs font-medium tracking-wider uppercase text-foreground-600 mb-6">
                What We Do
              </div>
              <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-foreground-950 mb-4">
                Our Services
              </h1>
              <p className="text-foreground-600 max-w-lg mx-auto">
                From interior walls to exterior facades, we deliver comprehensive painting and surface preparation solutions.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {services.map((service) => (
                <a
                  key={service.id}
                  href={`/portfolio?category=${serviceToCategory[service.id] || "All"}`}
                  className="group bg-background-100 rounded-2xl overflow-hidden flex flex-col md:flex-row hover:bg-background-200/70 transition-colors cursor-pointer"
                >
                  <div className="w-full md:w-2/5 h-56 md:h-auto shrink-0">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                  <div className="p-6 md:p-8 flex flex-col justify-center">
                    <h3 className="font-heading text-xl font-medium text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                      {service.title}
                    </h3>
                    <p className="text-sm text-primary-600 font-medium mb-3">
                      {service.subtitle}
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {service.description}
                    </p>
                    <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                      View Projects
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </div>
                </a>
              ))}
            </div>

            <div className="mt-14 bg-primary-500 rounded-2xl p-8 md:p-10 text-center">
              <h2 className="font-heading text-2xl md:text-3xl font-medium text-background-50 mb-3">
                Need Something Else?
              </h2>
              <p className="text-background-200/90 max-w-md mx-auto mb-6">
                We also offer drywall repair, texturing, and custom painting solutions. Contact us to discuss your project.
              </p>
              <a href="/contact" className="inline-flex items-center gap-2 bg-background-50 text-primary-600 px-6 py-3 rounded-full text-sm font-medium tracking-wider uppercase hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                Get a Quote
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}